
import axios from "axios";
import React, { useEffect, useState } from "react";
import AppConfig from './AppConfig.json'
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as actions from './actions'
import { validate } from 'jsonschema';
import ErrorMessage from "./ErrorMessage";

function DataField({ name, value, showNav, nameStyle, valueStyle, iconColor, onClick }) {
    return <div className="data-field" onClick={onClick}>
        <div className="data-name" style={nameStyle}>{name}</div>
        <div className="data-value" style={valueStyle}>{value}</div>
        {showNav && <div className="icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.64645 13.3536C5.45118 13.1583 5.45118 12.8417 5.64645 12.6464L10.2929 8L5.64645 3.35355C5.45118 3.15829 5.45118 2.84171 5.64645 2.64645C5.84171 2.45118 6.15829 2.45118 6.35355 2.64645L11.3536 7.64645C11.4473 7.74022 11.5 7.86739 11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355L6.35355 13.3536C6.15829 13.5488 5.84171 13.5488 5.64645 13.3536Z" fill={iconColor ? iconColor : 'white'} />
            </svg>
        </div>}
    </div>
}

function MemberEditEmail({ app, onUpdate }) {
    const { currentUserProfile } = app
    const history = useHistory()
    const [address, setAddress] = useState({
        homeNo: "",
        villageOrBuilding: "",
        moo: "",
        soi: "",
        road: "",
        typeOfHousing: "",
        country: "",
        city: "",
        district: "",
        subDistrict: "",
        postalCode: ""
    })
    const [resident, setResident] = useState([])
    const [province, setProvince] = useState([])
    const [district, setDistrict] = useState([])
    const [subDistrict, setSubDistrict] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        (async () => {
            let residents = await loadMasterData({
                lov_type: "CRC_HOUSE_TYPE",
            })
            setResident(residents)

            let provinces = await loadMasterData({
                lov_type: "CRC_CITY"
            })
            setProvince(provinces)

            if (currentUserProfile && currentUserProfile.address.length > 0) {
                let districts = []
                if (currentUserProfile.address[0].city) {
                    let p = provinces.filter(x => x.value === currentUserProfile.address[0].city)[0]
                    districts = await loadDistrict(p.name)
                }

                if (currentUserProfile.address[0].district) {
                    let p = districts.filter(x => x.value === currentUserProfile.address[0].district)[0]
                    await loadSubDistrict(p.name)
                }
            }
        })()

        if (currentUserProfile.address && currentUserProfile.address.length > 0) {
            setAddress(currentUserProfile.address[0])
        }
    }, [])

    async function loadDistrict(province) {
        console.log(province)
        let data = await loadMasterData({
            lov_type: "CRC_DISTRICT",
            parent_sub_type: "CRC_CITY",
            sub_type: province,
        })
        setDistrict(data)
        return data
    }

    async function loadSubDistrict(district) {
        console.log(district)
        let data = await loadMasterData({
            lov_type: "CRC_SUB_DISTRICT",
            parent_sub_type: "CRC_DISTRICT",
            sub_type: district,
        })
        setSubDistrict(data)
        return data
    }

    async function loadMasterData(options) {
        let result = await axios.post(`${AppConfig.endpoint}/member/master`, options, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        let items = result.data.map(item => item)
        console.log(items)
        return items
    }

    const formValidate = () => {
        var schema = {
            "type": "object",

            "properties": {
                homeNo: { "type": "string", minLength: 1 },
                villageOrBuilding: { "type": "string" },
                moo: { "type": "string" },
                soi: { "type": "string" },
                road: { "type": "string" },
                typeOfHousing: { "type": "string", minLength: 1 },
                // country: { "type": "string", minLength: 2 },
                city: { "type": "string", minLength: 1 },
                district: { "type": "string", minLength: 1 },
                subDistrict: { "type": "string", minLength: 1 },
                postalCode: { "type": "string", minLength: 1 }
            },
            required: ["homeNo", "road", "typeOfHousing", "city", "district", "subDistrict", "postalCode"]

        }

        console.log(address, schema, validate(address, schema).valid)
        let result = validate(address, schema)
        console.log(result)

        return result.valid
    }

    const sendUpdate = async () => {

        let body = { address: [{ ...address, addressType: "Contact Address", country: "Thailand" }] }

        let result = await axios.post(`${AppConfig.endpoint}/member/update/address`, body, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        console.log(result.data)
        if (result.data.success) {
            history.push("/member/profile")
            onUpdate && onUpdate()
        }
        else {
            setErrorMessage(result.data)
        }
    }

    if (!address.typeOfHousing && resident.length > 0) {
        address.typeOfHousing = resident[0].value
        setAddress({ ...address })
    }


    if (!address.city && province.length > 0) {
        address.city = province[0].value
        setAddress({ ...address })
        loadDistrict(province[0].name)
    }

    if (!address.district && district.length > 0) {
        address.district = district[0].value
        setAddress({ ...address })
        loadSubDistrict(district[0].name)
    }

    if (!address.subDistrict && subDistrict.length > 0) {
        address.subDistrict = subDistrict[0].value
        address.postalCode = subDistrict[0].high_value
        setAddress({ ...address })
    }



    return <div className="edit-screen pin-auth-screen">
        {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
        <div class="section-header">Address</div>
        <div className="edit-form">
            <div className="field">
                <label className="label">Home No. *</label>
                <div className="control">
                    <input className="input" type="text" value={address.homeNo} onChange={(e) => {
                        setAddress({ ...address, homeNo: e.target.value })
                    }} />
                </div>
            </div>

            <div className="field">
                <label className="label">Village/Building</label>
                <div className="control">
                    <input className="input" type="text" value={address.villageOrBuilding} onChange={(e) => {
                        setAddress({ ...address, villageOrBuilding: e.target.value })
                    }} />
                </div>
            </div>

            <div className="field">
                <label className="label">Moo</label>
                <div className="control">
                    <input className="input" type="text" value={address.moo} onChange={(e) => {
                        setAddress({ ...address, moo: e.target.value })
                    }} />
                </div>
            </div>


            <div className="field">
                <label className="label">Soi</label>
                <div className="control">
                    <input className="input" type="text" value={address.soi} onChange={(e) => {
                        setAddress({ ...address, soi: e.target.value })
                    }} />
                </div>
            </div>

            <div className="field">
                <label className="label">Street</label>
                <div className="control">
                    <input className="input" type="text" value={address.road} onChange={(e) => {
                        setAddress({ ...address, road: e.target.value })
                    }} />
                </div>
            </div>


            <div className="field">
                <label className="label">Residence Type *</label>
                <div className="control">
                    <div className="select">
                        <select value={address.typeOfHousing} onChange={(e) => {
                            setAddress({ ...address, typeOfHousing: e.target.value })
                        }}>
                            {resident.map(item => <option value={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>

            </div>

            <div className="field">
                <label className="label">Province *</label>
                <div className="control">
                    <div className="select">
                        <select value={address.city} onChange={(e) => {
                            let { value } = e.target
                            let cityItem = province.filter(x => x.value === value)[0]
                            setAddress({ ...address, city: cityItem.value })
                            loadDistrict(cityItem.name)
                        }}>
                            {province.map(item => <option value={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>


            <div className="field">
                <label className="label">District *</label>
                <div className="control">
                    <div className="select">
                        <select value={address.district} onChange={(e) => {
                            let { value } = e.target
                            let districtItem = district.filter(x => x.value === value)[0]
                            setAddress({ ...address, district: districtItem.value })
                            loadSubDistrict(districtItem.name)
                        }}>
                            {district && district.map(item => <option value={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <div className="field">
                <label className="label">Sub-district *</label>
                <div className="control">
                    <div className="select">
                        <select value={address.subDistrict} onChange={(e) => {
                            let postCode = subDistrict.filter(x => x.value === e.target.value)
                            setAddress({ ...address, subDistrict: e.target.value, postalCode: postCode.length > 0 ? postCode[0].high_value : "" })

                        }}>
                            {subDistrict && subDistrict.map(item => <option value={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <div className="field">
                <label className="label">Postal Code *</label>
                <div className="control">
                    <input className="input" type="text" value={address.postalCode} onChange={(e) => {
                        setAddress({ ...address, postalCode: e.target.value })
                    }} />
                </div>
            </div>
        </div>

        <div className="screen-footer">
            <button className="button is-fullwidth is-save" disabled={!formValidate()} onClick={() => sendUpdate()}>Continue</button>
        </div>
    </div>
}

export default withRouter(connect((state) => state, actions)(MemberEditEmail))